import {
  PERITADOR_ACT_VERIFICATION_BEGIN,
  PERITADOR_ACT_VERIFICATION_SUCCESS,
  PERITADOR_ACT_VERIFICATION_FAILURE,
  PERITADOR_ACT_VERIFICATION_DISMISS_ERROR,
} from './constants'
import { REACT_APP_PERITADOR_API } from '../../../common/config'
import axios from 'axios'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function actVerification(args = {}, statusId = '') {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PERITADOR_ACT_VERIFICATION_BEGIN,
    })

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let filterVerification = statusId ? `&filter[where][and][1][statusId]=${statusId}` :  ''

      const doRequest = axios.get(`${REACT_APP_PERITADOR_API}/verifications/findOne?filter[where][and][0][requestsId]=${args}${filterVerification}&filter[orderBy]="id DESC"&filter[include]=receptions&filter[include]=gestures`,
      )
      doRequest.then(
        (res) => {
          dispatch({
            type: PERITADOR_ACT_VERIFICATION_SUCCESS,
            data: res.data,
          })
          resolve(res)
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PERITADOR_ACT_VERIFICATION_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissActVerificationError() {
  return {
    type: PERITADOR_ACT_VERIFICATION_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PERITADOR_ACT_VERIFICATION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        actVerificationPending: true,
        actVerificationError: null,
      }

    case PERITADOR_ACT_VERIFICATION_SUCCESS:
      // The request is success
      return {
        ...state,
        actVerificationPending: false,
        actVerificationError: null,
        verification: action.data,
      }

    case PERITADOR_ACT_VERIFICATION_FAILURE:
      // The request is failed
      return {
        ...state,
        actVerificationPending: false,
        actVerificationError: action.data.error,
      }

    case PERITADOR_ACT_VERIFICATION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        actVerificationError: null,
      }

    default:
      return state
  }
}
